export default class OperationNotSupportedInThisEnvironmentError extends Error {
  constructor() {
    super("Operation is not supported in the environment.");
  }
}
